// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Headers
 */
/*
  Base Sizing
 */
/*
  Colors
 */
/*
  Border Radii Sizes
 */
/*
  Shadows
 */
/*
  Global Styles
 */
html {
  font-size: 10px;
}

/**
 * COODE Header Colors
 */
.linked-budget-request-view-content__empty-error .pui-loader-error__message {
  font-size: 16px;
  color: #adadad;
}
.linked-budget-request-view-content__breadcrumb {
  margin-bottom: 32px;
}
.linked-budget-request-view-content__breadcrumb .pui-breadcrumb .pui-breadcrumb-item span {
  color: #4a4a4a;
}
.linked-budget-request-view-content__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
}
.linked-budget-request-view-content__header__title {
  color: #4a4a4a;
}
.linked-budget-request-view-content__header__actions {
  display: flex;
  gap: 10px;
}
.linked-budget-request-view-content__header__actions__delete.pui-button.secondary {
  border-color: #F03529;
  color: #F03529;
}
.linked-budget-request-view-content__header__actions__delete.pui-button.secondary:hover {
  border-color: #911420;
  color: #911420;
}
.linked-budget-request-view-content .pui-card-label-text {
  margin-bottom: 16px;
}
.linked-budget-request-view-content .pui-card-label-text p {
  margin: 0;
}
.linked-budget-request-view-content__chip-list {
  margin-right: 4px;
}
.linked-budget-request-view-content .pui-chip__text {
  display: flex;
}
.linked-budget-request-view-content .pui-collapsible__header {
  font-weight: bold;
}
.linked-budget-request-view-content__container {
  padding: 20px;
}
.linked-budget-request-view-content__container__section-margin-top {
  margin-top: 24px;
}
.linked-budget-request-view-content__scrollable-row {
  display: flex;
  overflow: auto;
  padding-bottom: 16px;
}
.linked-budget-request-view-content__scrollable-row--center .pui-grid-col {
  text-align: center;
}
.linked-budget-request-view-content__scrollable-row .pui-grid-col {
  min-width: 200px;
}
.linked-budget-request-view-content__separator {
  border-color: #adadad;
  margin: 16px 0 16px 0;
}
.linked-budget-request-view-content__headline .pui-headline {
  text-transform: uppercase;
  font-weight: bold;
  color: #4a4a4a;
  margin-bottom: 32px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
